const flattenSingleLevelArray = arr =>
  arr.reduce((acc, val) => acc.concat(val), []);

export default flattenSingleLevelArray;
